import { useState } from 'react';
import { useSession } from './auth/SessionContext';
import { LoginScreen } from './auth/LoginScreen';
import { Library } from './library/Library';
import { Editor } from './editor/Editor';
import type { Photo } from './types';

export function App() {
  const { authenticated, loading } = useSession();
  const [editing, setEditing] = useState<Photo | null>(null);

  if (loading) {
    return <div className="boot">Loading…</div>;
  }

  if (!authenticated) {
    return <LoginScreen />;
  }

  if (editing) {
    return <Editor photo={editing} onBack={() => setEditing(null)} />;
  }

  return <Library onOpenEditor={setEditing} />;
}
